var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7CBAF8FC-4576-40C6-B231-3ABA982006CC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication-&-Connectivity",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communication&Connectivity/Wifi/Connected/24",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5366896,19.2942858 C13.5366896,20.1390696 12.8498664,20.8235294 12.0021657,20.8235294 C11.152918,20.8235294 10.4676417,20.1390696 10.4676417,19.2942858 C10.4676417,18.4495021 11.152918,17.7650422 12.0021657,17.7650422 C12.8498664,17.7650422 13.5366896,18.4495021 13.5366896,19.2942858 M12.002011,8.58834741 C14.9859795,8.58834741 17.6945999,9.72757222 19.7365068,11.5867131 L19.7365068,11.5867131 L18.6459429,12.6735243 C16.880931,11.0903256 14.5574884,10.117591 12.002011,10.117591 C9.44808044,10.117591 7.12154409,11.088784 5.35498523,12.6704412 L5.35498523,12.6704412 L4.32784419,11.5820884 C6.37129799,9.72603065 9.01958937,8.58834741 12.002011,8.58834741 Z M12.0015469,4 C16.2570665,4 20.1196737,5.64948654 23,8.33491228 L23,8.33491228 L21.910983,9.42018193 C19.3075517,7.00761517 15.8285754,5.52924359 12.0015469,5.52924359 C8.17915905,5.52924359 4.69399522,7.00761517 2.09056392,9.4155572 L2.09056392,9.4155572 L1,8.33028755 C3.88032626,5.64640338 7.74757418,4 12.0015469,4 Z M8.61646744,15.9207005 C9.54306005,15.1668697 10.7171565,14.7059384 12.0010828,14.7059384 C13.2881029,14.7059384 14.4606525,15.1684113 15.3841513,15.9237836 L16.4731683,14.838514 C15.2696808,13.8087411 13.7135002,13.1766948 12.0010828,13.1766948 C10.2917592,13.1766948 8.73248488,13.8071995 7.52745043,14.8354308 L8.61646744,15.9207005 Z",
    id: "WifiConnected"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.dce174d13116fea4a012516572fa5569.svg";
export { ForwardRef as ReactComponent };